module.exports = __webpack_public_path__ + "img/banner.0fbaabf7.png";